import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./app/App";
import { AuthProvider } from "./auth";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./styles/main.scss";


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <AuthProvider>
      <App />
    </AuthProvider>
);
